import React, { useState } from "react";
import FormForemanSection1 from "../components/FormForemanSection1";
import FormForemanSection2 from "../components/FormForemanSection2";

const FormForeman = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => setCurrentStep(2);
  const handleBack = () => setCurrentStep(1);
  const handleComplete = () => (window.location.href = "/menu-absensi");

  return (
    <div>
      {currentStep === 1 && <FormForemanSection1 onNext={handleNext} />}
      {currentStep === 2 && (
        <FormForemanSection2 onComplete={handleComplete} onBack={handleBack} />
      )}
    </div>
  );
};

export default FormForeman;
